import React from 'react';
import { useDispatch } from 'react-redux';

import { dashboardClienteAction } from "components/ApplicationInsights/eventNames";
import InvoiceSlider from 'components/InvoiceSlider';
import { MenuItem } from "..";

import nf from 'img/menu-icon-nf.svg';

import { IMenuItem } from '../interface';

interface IProps {
  itemComponent: React.FC<IMenuItem>,
  clickAction?: Function;
}

const Invoice: React.FC<IProps> = (props: IProps) => {
  const { itemComponent, clickAction } = props;

  const dispatch = useDispatch();

  const defaultClickAction = () => {
    dispatch({
      type: 'OPEN_SLIDER',
      data: {
        title: 'Notas Fiscais',
        subtitle:
          'Utilize os campos abaixo para localizar o seu pedido.',
        show: true,
        content: InvoiceSlider,
      },
    });
  };

  return React.createElement(itemComponent, {
    title: "NOTAS",
    subtitle: "FISCAIS",
    icon: nf,
    trackName: dashboardClienteAction.DASHCLIENTE_NOTASFISCAIS,
    onClick: () => clickAction ? clickAction() : defaultClickAction(),
    id: "invoice-menu-item"
  });
};

export default Invoice;